import useContext from 'nette-base-module/js/views'

useContext(require.context(
  // root folder for components
  './',
  // recursive
  true,
  // include all .js wo index.js
  /\/(?!index\.js$)(.*\.js$)/,
))